/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_SearchInputs */

const en_shortcut_search = /** @type {(inputs: Shortcut_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search the list`)
};

/**
* | output |
* | --- |
* | "Search the list" |
*
* @param {Shortcut_SearchInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const shortcut_search = /** @type {((inputs?: Shortcut_SearchInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_SearchInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_shortcut_search(inputs)
});